import { Controls } from '../../services/controls';
import { IPromiseAction } from '../../models/ActionModels';
import Actions from '../../actions/ActionWrapper';
import { ActionSubTypes } from '../../actions/ActionSubTypes';
import { CustomCookieManager } from '../../api/core/CustomCookieManager';
import { IError } from '../../models/StateModels';
import { HttpClientResult } from '../../api/core/HttpClientSelector';

export const PromiseMiddleware = (store: any) => (next: any) => (action: IPromiseAction) => {
  if (Controls.IsPromise(action.payload?.promise)) {
    action.payload.promise
      .then((res: HttpClientResult) => {
        if (res?.status && !res.status.toString().startsWith('2'))
          throw {
            Code: res.status.toString(),
            Title: 'Sunucu Erişim Hatası',
            Message: res.data,
          };
        if (res?.headers) {
          CustomCookieManager.GetCookies(res.headers);
        }
        if (res?.data?.d?.Error) {
          throw {
            Code: res.data.d.MessageCode,
            Title: res.data.d.MessageTitle,
            Message: res.data.d.Message,
          };
        }
        return res?.data?.d || res;
      })
      .then(
        (res: any) => {
          switch (action.subtype) {
            case ActionSubTypes.API_OTURUMAC:
              store.dispatch(Actions.Api.User.Login.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OTURUMKAPAT:
              store.dispatch(Actions.Api.User.Logout.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_SORGUINPUTLARI:
              store.dispatch(Actions.Api.Veri.SorguInputlari.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_ANASAYFAUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.Anasayfa.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_FAALIYETALANIUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.FaaliyetAlani.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_KIRAGENELBILGI:
              store.dispatch(Actions.Api.Bilgi.KiraGenelBilgi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_KIRABILGI:
              store.dispatch(Actions.Api.Bilgi.KiraBilgi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_MADENSAHALARIGENELBILGI:
              store.dispatch(Actions.Api.Bilgi.MadenSahalariGenelBilgi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_MADENSAHALARIBILGI:
              store.dispatch(Actions.Api.Bilgi.MadenSahalariBilgi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKGMCIROBAZLILISTE:
              store.dispatch(Actions.Api.Bilgi.OyakGmCiroBazliListe.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_SORGULAMASONUCLARILISTE:
              store.dispatch(Actions.Api.Bilgi.SorgulamaSonuclariListe.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_TIKLAMASONUCLARILISTE:
              store.dispatch(Actions.Api.Bilgi.TiklamaSonuclariListe.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKPROJETOPLAMHAKEDISLISTE:
              store.dispatch(
                Actions.Api.Bilgi.OyakProjeToplamHakedisListe.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_GRUPSIRKETIUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.GrupSirketi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_GAYRIMENKULALAN:
              store.dispatch(Actions.Api.Stat.GayrimenkulAlan.Toplam.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_GAYRIMENKULSAYI:
              store.dispatch(Actions.Api.Stat.GayrimenkulSayi.Toplam.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_GAYRIMENKULTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulToplamDeger.Toplam.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_KULLANIMAMACLIGAYRIMENKULALAN:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulAlan.KullanimAmacli.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_KULLANIMAMACLIGAYRIMENKULSAYI:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulSayi.KullanimAmacli.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_KULLANIMAMACLIGAYRIMENKULTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulToplamDeger.KullanimAmacli.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_YATIRIMAMACLIGAYRIMENKULALAN:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulAlan.YatirimAmacli.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_YATIRIMAMACLIGAYRIMENKULSAYI:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulSayi.YatirimAmacli.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_YATIRIMAMACLIGAYRIMENKULTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulToplamDeger.YatirimAmacli.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_DEGERLEMETOPLAMDEGER:
              store.dispatch(Actions.Api.Stat.Degerleme.Toplam.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_GRUPSIRKETLISTELE:
              store.dispatch(Actions.Api.Veri.GrupSirketListele.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_FAALIYETALANILISTESI:
              store.dispatch(Actions.Api.Veri.FaaliyetAlaniListesi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_HARITADAARA:
              store.dispatch(Actions.Api.Veri.HaritadaAra.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.OyakKiraBilgileriUstBilgi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIKVTDETAY:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraBilgileriUstBilgiKvtDetay.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIYKGDETAY:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraBilgileriUstBilgiYkgDetay.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIAKGDETAY:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraBilgileriUstBilgiAkgDetay.asyncComplete(res, null)
              );
              break;
            //Tayfun
            case ActionSubTypes.API_YURTDISITASINMAZGENELBILGI:
              store.dispatch(
                Actions.Api.Bilgi.YurtDisiTasinmazlariGenelBilgi.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_YURTDISITASINMAZBILGI:
              store.dispatch(Actions.Api.Bilgi.YurtDisiTasinmazlariBilgi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_PROJELISTELE:
              store.dispatch(Actions.Api.Veri.ProjeListele.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKKIRATRGENELIKIRAYAVERILENTASINMAZLAR:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraTrGeneliKirayaVerilenTasinmazlar.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_UIVERSIONKONTROL:
              store.dispatch(Actions.Api.User.UiVersionKontrol.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_GRUPSIRKETDEGERLEMEUSTBILGI:
              store.dispatch(
                Actions.Api.Bilgi.GrupSirketDegerlemeUstBilgi.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_OYAKDEGERLEMEUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.OyakDegerlemeUstBilgi.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKDEGERLEMETOPLAMDEGER:
              store.dispatch(Actions.Api.Stat.OyakDegerleme.Toplam.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKKIRATRGENELIAYLIKGELIRDAGILIMILISTELE:
              store.dispatch(
                Actions.Api.Stat.OyakKiraTrGeneliAylikGelirDagilimiListele.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_OYAKKIRATRGENELIYILLIKGELIRDAGILIMILISTELE:
              store.dispatch(
                Actions.Api.Stat.OyakKiraTrGeneliYillikGelirDagilimiListele.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_KULLANICIKONTROL:
              store.dispatch(Actions.Api.User.KullaniciKontrol.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OTPAL:
              store.dispatch(Actions.Api.User.OtpAl.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OTPKONTROL:
              store.dispatch(Actions.Api.User.OtpKontrol.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_SIFREMIUNUTTUM:
              store.dispatch(Actions.Api.User.SifremiUnuttum.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_SIFREDEGISTIR:
              store.dispatch(Actions.Api.User.SifreDegistir.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKEMLAKVERGILERI:
              store.dispatch(Actions.Api.Stat.OyakEmlakVergileri.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_OYAKEMLAKVERGILERIDETAYTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.OyakEmlakVergileriDetayToplamDeger.asyncComplete(res, null)
              );
              break;
            case ActionSubTypes.API_USTBILGIISTATISTIKDETAY:
              store.dispatch(Actions.Api.Bilgi.UstBilgiIstatistikDetay.asyncComplete(res, null));
              break;
            case ActionSubTypes.API_RAPORURLGETIR:
              store.dispatch(Actions.Api.Veri.RaporUrlGetir.asyncComplete(res, null));
              break;

            default:
              break;
          }
        },
        (error: any) => {
          const ierror: IError = {
            ErrorCode: error?.Code,
            ErrorTitle: error?.Title,
            ErrorMessage: error.Message || error,
            ErrorDateTime: new Date().toISOString(),
          };
          switch (action.subtype) {
            case ActionSubTypes.API_OTURUMAC:
              store.dispatch(Actions.Api.User.Login.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OTURUMKAPAT:
              store.dispatch(Actions.Api.User.Logout.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_SORGUINPUTLARI:
              store.dispatch(Actions.Api.Veri.SorguInputlari.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_ANASAYFAUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.Anasayfa.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_FAALIYETALANIUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.FaaliyetAlani.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_GRUPSIRKETIUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.GrupSirketi.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_KIRAGENELBILGI:
              store.dispatch(Actions.Api.Bilgi.KiraGenelBilgi.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_KIRABILGI:
              store.dispatch(Actions.Api.Bilgi.KiraBilgi.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_MADENSAHALARIGENELBILGI:
              store.dispatch(Actions.Api.Bilgi.MadenSahalariGenelBilgi.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_MADENSAHALARIBILGI:
              store.dispatch(Actions.Api.Bilgi.MadenSahalariBilgi.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OYAKGMCIROBAZLILISTE:
              store.dispatch(Actions.Api.Bilgi.OyakGmCiroBazliListe.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_SORGULAMASONUCLARILISTE:
              store.dispatch(Actions.Api.Bilgi.SorgulamaSonuclariListe.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_TIKLAMASONUCLARILISTE:
              store.dispatch(Actions.Api.Bilgi.TiklamaSonuclariListe.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OYAKPROJETOPLAMHAKEDISLISTE:
              store.dispatch(
                Actions.Api.Bilgi.OyakProjeToplamHakedisListe.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_UIVERSIONKONTROL:
              store.dispatch(Actions.Api.User.UiVersionKontrol.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_GAYRIMENKULALAN:
              store.dispatch(Actions.Api.Stat.GayrimenkulAlan.Toplam.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_GAYRIMENKULSAYI:
              store.dispatch(Actions.Api.Stat.GayrimenkulSayi.Toplam.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_GAYRIMENKULTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulToplamDeger.Toplam.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_KULLANIMAMACLIGAYRIMENKULALAN:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulAlan.KullanimAmacli.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_KULLANIMAMACLIGAYRIMENKULSAYI:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulSayi.KullanimAmacli.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_KULLANIMAMACLIGAYRIMENKULTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulToplamDeger.KullanimAmacli.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_YATIRIMAMACLIGAYRIMENKULALAN:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulAlan.YatirimAmacli.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_YATIRIMAMACLIGAYRIMENKULSAYI:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulSayi.YatirimAmacli.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_YATIRIMAMACLIGAYRIMENKULTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.GayrimenkulToplamDeger.YatirimAmacli.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_DEGERLEMETOPLAMDEGER:
              store.dispatch(Actions.Api.Stat.Degerleme.Toplam.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_GRUPSIRKETLISTELE:
              store.dispatch(Actions.Api.Veri.GrupSirketListele.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_FAALIYETALANILISTESI:
              store.dispatch(Actions.Api.Veri.FaaliyetAlaniListesi.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_HARITADAARA:
              store.dispatch(Actions.Api.Veri.HaritadaAra.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGI:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraBilgileriUstBilgi.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIKVTDETAY:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraBilgileriUstBilgiKvtDetay.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIYKGDETAY:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraBilgileriUstBilgiYkgDetay.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIAKGDETAY:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraBilgileriUstBilgiAkgDetay.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_YURTDISITASINMAZGENELBILGI:
              store.dispatch(
                Actions.Api.Bilgi.YurtDisiTasinmazlariGenelBilgi.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_OYAKKIRATRGENELIKIRAYAVERILENTASINMAZLAR:
              store.dispatch(
                Actions.Api.Bilgi.OyakKiraTrGeneliKirayaVerilenTasinmazlar.asyncComplete(
                  null,
                  ierror
                )
              );
              break;
            case ActionSubTypes.API_YURTDISITASINMAZBILGI:
              store.dispatch(
                Actions.Api.Bilgi.YurtDisiTasinmazlariBilgi.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_PROJELISTELE:
              store.dispatch(Actions.Api.Veri.ProjeListele.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_GRUPSIRKETDEGERLEMEUSTBILGI:
              store.dispatch(
                Actions.Api.Bilgi.GrupSirketDegerlemeUstBilgi.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_OYAKDEGERLEMEUSTBILGI:
              store.dispatch(Actions.Api.Bilgi.OyakDegerlemeUstBilgi.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OYAKDEGERLEMETOPLAMDEGER:
              store.dispatch(Actions.Api.Stat.OyakDegerleme.Toplam.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OYAKKIRATRGENELIAYLIKGELIRDAGILIMILISTELE:
              store.dispatch(
                Actions.Api.Stat.OyakKiraTrGeneliAylikGelirDagilimiListele.asyncComplete(
                  null,
                  ierror
                )
              );
              break;
            case ActionSubTypes.API_OYAKKIRATRGENELIYILLIKGELIRDAGILIMILISTELE:
              store.dispatch(
                Actions.Api.Stat.OyakKiraTrGeneliYillikGelirDagilimiListele.asyncComplete(
                  null,
                  ierror
                )
              );
              break;
            case ActionSubTypes.API_KULLANICIKONTROL:
              store.dispatch(Actions.Api.User.KullaniciKontrol.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OTPAL:
              store.dispatch(Actions.Api.User.OtpAl.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OTPKONTROL:
              store.dispatch(Actions.Api.User.OtpKontrol.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_SIFREMIUNUTTUM:
              store.dispatch(Actions.Api.User.SifremiUnuttum.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_SIFREDEGISTIR:
              store.dispatch(Actions.Api.User.SifreDegistir.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OYAKEMLAKVERGILERI:
              store.dispatch(Actions.Api.Stat.OyakEmlakVergileri.asyncComplete(null, ierror));
              break;
            case ActionSubTypes.API_OYAKEMLAKVERGILERIDETAYTOPLAMDEGER:
              store.dispatch(
                Actions.Api.Stat.OyakEmlakVergileriDetayToplamDeger.asyncComplete(null, ierror)
              );
              break;
            case ActionSubTypes.API_RAPORURLGETIR:
              store.dispatch(Actions.Api.Veri.RaporUrlGetir.asyncComplete(null, ierror));
              break;

            default:
              break;
          }
        }
      );
  }
  next(action);
};
